/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { OperationHandler } from 'src/core/services/api/createOperationCall';
import { OperationDelayStrategies } from 'src/core/utils/api/operationDelayStrategies';
import { DisposableLifetime } from 'src/core/utils/lifetime';
import { EvaluationJobStore } from 'src/modules/modelEvaluation/EvaluationJobInfoStore';
import { EvaluationOnDemandJobSwagger } from 'src/modules/modelEvaluation/modelEvaluationSwaggers';

export const getEvaluationJobOperationHandler = (
    lifetime: DisposableLifetime,
    evaluationJobStore: EvaluationJobStore
): OperationHandler<EvaluationOnDemandJobSwagger> => ({
    retryStrategy: res =>
        !lifetime.isDisposed && res.data.status !== 'succeeded' && res.data.status !== 'failed' && res.data.status !== 'cancelled',
    timeToDelay: OperationDelayStrategies.exponentialDelayStrategy,
    handleCall: data => {
        if (lifetime.isDisposed) {
            return;
        }

        evaluationJobStore?.updateData({
            percentComplete: Math.floor(data.result.percentComplete),
            status: data.status === 'running' ? 'inProgress' : data.status,
            startDateTime: new Date(data.createdDateTime),
            endDateTime: data.status === 'succeeded' ? new Date(data.lastUpdatedDateTime) : null,
            errors: data.errors?.map(e => e.message) ?? []
        });
    }
});
